import React from 'react';
import styled from 'styled-components';

import { MobileFilterIcon } from 'src/assets/mobile-filter-icon';
import useTranslation from 'hooks/use-translation';
import { Clickable } from 'shared/components';

type DrawerToggleButtonProps = {
  onClick: () => void;
  filterCount?: number;
};

export function DrawerToggleButton({ onClick, filterCount }: DrawerToggleButtonProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Clickable onClick={onClick}>
      <ContentContainer>
        <MobileFilterIcon />
        <Text>{t('common.filter_plural', 'Filters')}</Text>
        {(filterCount ?? 0) > 0 && <FilterCount>{filterCount}</FilterCount>}
      </ContentContainer>
    </Clickable>
  );
}

const FilterCount = styled.div`
  border-radius: 50%;
  width: 19px;
  height: 19px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  padding: 3px;
  display: inline-block;
  margin-left: 0;
  background: var(--dct--customized-colors-buttonsLinks);
  color: ${({ theme }) => theme.colors.white};
`;

const Text = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.primaryBlack};
`;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  svg {
    color: #828a8f;
  }
`;
